"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GEOLOCATION_LOCAL_STORAGE_KEY = exports.COUNTRY_CODE_COOKIE_NAME = void 0;
const COUNTRY_CODE_COOKIE_NAME = exports.COUNTRY_CODE_COOKIE_NAME = 'country-code';
const GEOLOCATION_LOCAL_STORAGE_KEY = exports.GEOLOCATION_LOCAL_STORAGE_KEY = 'hideGeolocationUntil';
